// extracted by mini-css-extract-plugin
export default {"letter":"Control_letter__WoFvv","item":"Control_item__6-R4t","room":"Control_room__46Wv9"};